import React from 'react';
import './LegendItem.scss';

interface LegendItemProps {
  isSelected: boolean;
  label: string;
  color: string;
  legendItemHandler: (label: string) => void;
}

const LegendItem: React.FC<LegendItemProps> = ({ isSelected, label, color, legendItemHandler }) => {
  return (
    <div
      className={`legend-item ${isSelected ? 'legend-item--active' : ''}`}
      onClick={() => legendItemHandler(label)}
    >
      <span>
        <span className="legend-item__color" style={{ background: color }} />
        {label}
      </span>
    </div>
  );
};

export default LegendItem;
